const Module = () => import('./Module.vue')
const SubReport = () => import('./views/SubReport.vue')

const moduleRoute = {
  path: '/subreport',
  component: Module,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      name: 'SubReport',
      path: ':userId',
      component: SubReport,
      props: route => ({
        userId: route.params.userId,
        campaignId: route.query.campaignId,
        reportType: route.query.reportType,
        pdf: String(route.query.pdf).toLowerCase() === 'true',
        anonymized: !route.query.anonymized || String(route.query.anonymized).toLowerCase() === 'true'
      })
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
